/* ref https://developers.google.com/chart/interactive/docs/gallery/timeline */
const debug = process.env.REACT_APP_DEBUG && false;
export const colorMap = {
    UNSCHEDULED_OPERATION: 'orange',
    OPERATING_NO_ACCELEROMETER_OUTPUT: 'darkgray',
    ACTIVE_PATTERN_CONFLICTS_SPRINKLER_ACTIVE: 'brown',
    NORMAL_OFF: 'lightgrey',
    NORMAL_ON: 'lightgreen',
    ACKNOWLEDGING_DOWNLINK: 'cyan',
    BATTERY_ERROR: 'pink',
    LINK_CHECK_ERROR: 'deeppink',
    LOW_BATTERY_WARNING: 'red',
    DOWNLINK_PARSING_ERROR: 'blue',
    SPRINKLER_ACTIVE_CONFLICTS_SPRINKLER_ACTIVE_PATTERN: 'lightcoral',
    RUNAWAY_ERROR: 'yellow',
    SCHEDULE_ERROR: 'black',
    SOLENOID_DISCONNECTED_ERROR: 'pink',
    SOLENOID_FIRE_ERROR: 'purple',
    TIME_NOT_SET_ERROR: 'magenta',
};
